import { UserContainer } from './components/pantallasComponents';
import Card from '../components/Card/Card';
import Paper from "@mui/material/Paper";
import inicio from "../extras/image/CoCo.gif";

function Pantallas() {
  return (
    <UserContainer>
      <Card>
        <Paper square>
          <img width='100%' src={inicio} />
        </Paper>
      </Card>
    </UserContainer>
  );
}

export default Pantallas;
